import React, { useState } from 'react';
import { uploadUrl } from '../../../functions/Api';
import { Button } from '@asu/unity-react-core';

const UploadByUrl = (props) => {
  const [url, setUrl] = useState('https://');
  const uploadFiles = async () => {
    props.setUploading(true);

    for (const selectedClass of props.classes) {
      try {
        let result = await uploadUrl(url, selectedClass);

        props.setUploadResults((results) => {
          return results.concat(result);
        });
      } catch (error) {
        props.setErrors((e) => {
          if (e.includes(error)) {
            return e;
          } else {
            return e.concat(error);
          }
        });
      }
    }

    props.updateSyllabusStatus();

    props.setUploading(false);
  };

  const changeHandler = (e) => {
    setUrl(e.target.value);
  };

  const handleSave = () => {
    const pattern = new RegExp(
      '^(https:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', // fragment locator
      'i'
    );
    let val = pattern.test(url);

    if (val) {
      uploadFiles();
    } else {
      alert('Enter valid URL');
    }
  };

  return (
    <div className="action-buttons">
      <p>
        Please verify that the URL is a publicly-reachable URL, eg.,{' '}
        <a href="https://www.asu.edu">https://www.asu.edu</a>
      </p>
      <div className="form-row mb-2">
        <div className="form-group">
          <input
            className="form-control"
            id="url"
            type="text"
            name="url"
            value={url}
            onChange={changeHandler}
          />
        </div>
      </div>
      <Button label="Save" color="maroon" onClick={handleSave} />
    </div>
  );
};

export default UploadByUrl;
